import { ReservaCriacaoOrigem } from "core/features/reservas/typings";
import TagStatus from "./TagStatus";

interface FiltroTagCriacaoOrigemProps {
  selectedOrigem?: ReservaCriacaoOrigem;
  setSelectedOrigem?: (tipo?: ReservaCriacaoOrigem) => any;
}

function FiltroTagOrigemCriacao({
  selectedOrigem,
  setSelectedOrigem,
}: FiltroTagCriacaoOrigemProps) {
  const onSelectTipoStatus = (t: ReservaCriacaoOrigem) => {
    if (selectedOrigem === t) {
      setSelectedOrigem?.(undefined);
    } else {
      setSelectedOrigem?.(t);
    }
  };

  return (
    <>
      <TagStatus
        onClick={() => onSelectTipoStatus?.(ReservaCriacaoOrigem.App)}
        selected={selectedOrigem === ReservaCriacaoOrigem.App}
      >
        App
      </TagStatus>

      <TagStatus
        onClick={() => onSelectTipoStatus?.(ReservaCriacaoOrigem.Backoffice)}
        selected={selectedOrigem === ReservaCriacaoOrigem.Backoffice}
      >
        Backoffice
      </TagStatus>
    </>
  );
}

export default FiltroTagOrigemCriacao;
